import { UAParser } from 'ua-parser-js';

const ua = new UAParser();

export const getIsMacSafari = (): boolean => {
  const browser = ua.getBrowser().name;
  const os = ua.getOS().name;
  if (!browser || !os) {
    return false;
  }
  return (
    (browser.includes('Safari') && os.includes('Mac')) ||
    // In Mac Outlook desktop, browser name is returned as WebKit
    (browser.includes('WebKit') && os.includes('Mac'))
  );
};
